app.controller('dashboardController', function ($rootScope, $scope, $sce, $http, $location, $window, systemService, appealsService, safeApply) {

  const currentDate = new Date()
  const CurrentYear = currentDate.getFullYear()
  
  $scope.stats      = { customer: [], county: [], transactions: [] }
  $scope.countyData = []

  $scope.loading = { customer: true, county: true, transactions: true, last_refresh: '' }
  
  initController()
  async function initController() {
    await loadCountyList()
    allRefresh()    
  }

  // https://clipboardjs.com/       
  function clipboard_js() {
    let clipboard = new ClipboardJS('.fa-copy')
  }

  $scope.refreshStats = () => {
    allRefresh()
  }

  async function allRefresh() {
    $scope.loading = { customer: true, county: true, transactions: true }
    let element = document.querySelector('.fa-sync');
    element.classList.add('fa-spin')
    Promise.allSettled([loadAppealStatuses(), loadCustomerStatuses(), loadTransactionStatuses()]).
      then(() => { 
        $scope.loading.last_refresh = new Date()
        element.classList.remove('fa-spin')
        safeApply($scope)
      })
  }

  async function loadCountyList() {
    let countyListResults = await systemService.functionCall({ type: "countyList", active_only: false })
    if (countyListResults.data.success && countyListResults.data.data.length > 0) {
      $scope.countyData = countyListResults.data.data
      let c  = countyListResults.data.data,
          cl = {}
      c.map(item => {
        cl[item.cad_code] = item
      })
      $scope.countyList = cl
    } else {
      console.log("*** System Error ***")
    }    
    safeApply($scope)
  }

  async function loadTransactionStatuses() {
    let getTransactionsStatsResults = await systemService.functionCall({ type: "getTransactionsStats" })
        $scope.stats.transactions   = getTransactionsStatsResults.data.data
        $scope.loading.transactions = false
    safeApply($scope)
  }

  async function loadCustomerStatuses() {
    let getCustomerStatsResults = await systemService.functionCall({ type: "getCustomerStats" })
        $scope.stats.customer   = getCustomerStatsResults.data.data.stats
        $scope.stats.clients    = getCustomerStatsResults.data.data.clients
        console.log('$scope.stats.clients :>> ', $scope.stats.clients);
        $scope.loading.customer = false
    safeApply($scope)
    setTimeout(() => {
      clipboard_js()
    }, 1000)
  }

  async function loadAppealStatuses() {
    let getCountyStatsResults = await systemService.functionCall({ type: "getCountyStats", countyList: $scope.countyList })
    $scope.stats.county       = getCountyStatsResults.data.data
    
    let total = $scope.stats.county.total
    for (const element in $scope.stats.county.breakdown) {
      let item = $scope.stats.county.breakdown[element]
      item.percentage_gold   = (item.gold / item.count)*100
      item.percentage_silver = (item.silver / item.count)*100
      item.percentage_total  = ( item.count / total )*100
    }
    
    $scope.loading.county = false
    safeApply($scope)
    console.log('$scope.stats.county :>> ', $scope.stats.county);
  }

  $scope.route = (action, obj) => {
    let url = ''
    switch (action) {
      case 'dashboard':
        url = `https://dashboard.propertytax.io/${obj.id}/${obj.token}`
        window.open(url, '_blank')
        break
    }
  }
  
})

